import FuncConfig from "./FuncConfig";

const firebaseConfig = {
  apiKey: "AIzaSyCe8zSbV8YsL_aAmiA_cPEqnfIrJoM6dag",
  authDomain: "app.acespokerrun.com",
  projectId: "acespokerrun-prod",
  storageBucket: "acespokerrun-prod.appspot.com",
  messagingSenderId: "910630651104",
  appId: "1:910630651104:web:9fe0af870ccb6381dcfc85",
  measurementId: "G-94C5GRYCS3",
};

const paymentConfig = {
  stripePublishableKey:
    "pk_live_51MPcN7JJsANWJ1Qd198GeCn2qrfizKGPC18BudPPQSa1g6wvCcaXPdt7iPZwcniPL4ksKIYatuwqIuXpWpRsDDMk00zDsRTom0",
  returnUrl: "https://app.acespokerrun.com//PaymentConfirmation",
};


const googlePlayConfig = {
  appPackage: "com.acespokerrun.app.twa",
  fallbackUrl: "https://app.acespokerrun.com",
  appUrl:"https://play.google.com/store/apps/details?id=com.acespokerrun.app.twa",
  appReviewUrl: "https://play.google.com/store/apps/details?id=com.acespokerrun.app.twa&reviewId=0",
};

const iosConfig = {
  appUrl:"https://apps.apple.com/us/app/aces-fun-run/id6448767307",
  appReviewUrl: "https://apps.apple.com/us/app/aces-fun-run/id6448767307?action=write-review",
  bundleId: "com.acespokerrun.app.service",
};


const googleMapsConfig = {
  apiKey: "AIzaSyDTS9bBMxLImyviPw8NUtRUtaVJAofoDLQ",
  mapId: "b67aefe6cb49e3c0",
};

const links = {
  privacyPolicy: "https://help.acespokerrun.com/en/articles/11498981-privacy-policy",
  termsOfService: "https://help.acespokerrun.com/en/articles/11498978-terms-of-service",
  help: "https://help.acespokerrun.com/en",
  SetupEventInfo: "",
  SetupEventFinanical: "",
  SetupExtraCard: "",
  SetupEventFee: "",
  SetupEventStops: "",
  SetupEventStop: "",
  SetupEventSummary: "",
  SetupEventWaiver: "",
  EventRegistration: "",
  signIn: "",
};

class Config {
  public buildNumber = "__BUILD_NUMBER__";

  public Url = "https://app.acespokerrun.com";
  
  public LinkUrl = "https://aces-links.acespokerrun.com/?target=";
  
  public functions = FuncConfig;

  public FirebaseConfig = firebaseConfig;

  public paymentConfig = paymentConfig;
  
  public googlePlayConfig = googlePlayConfig;

  public googleMapsConfig = googleMapsConfig;

  public iosConfig = iosConfig;

  public links = links;

  public sentryTargets = [/^https:\/\/app.acespokerrun\.com/];

  public sentryProject = "aces-prod";

  public sentryIngestUrl = "https://3f5434426d494dc8832c40c3b79fac03@o4505482162339840.ingest.sentry.io/4505488887316480";

  public requireApp = true;
}

export default new Config();
